<template>
  <div :class="['spinner', { 'spinner--large': large }]"></div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    large?: boolean;
  }>(),
  {
    large: false,
  },
);
</script>
